import { Component, OnInit, OnDestroy ,ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {NgbModal , NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Formatters,OnEventArgs,Formatter} from 'angular-slickgrid';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs'; 
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {ConfigService} from '../config.service';
// import { AnyMxRecord } from 'dns';
// const myCustomCheckmarkFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
//     return value ? `<i class="fa fa-fire red" aria-hidden="true"></i>` : { text: '<i class="fa fa-snowflake-o" aria-hidden="true"></i>', addClasses: 'gg-lock', toolTip: 'Change Password' };
//   };
  


@Component({
    selector: 'app-usercreation',
    templateUrl: './usercreation.component.html',
    styleUrls: ['./usercreation.component.css']
})
export class UsercreationComponent implements OnInit, OnDestroy {
    displayed = true;
    mobile: string;
    email: string;
    address: string;
    fullname: string;
    password: string;
    clients: any[];
    clientSelected: number;
    show: boolean;
    selected: number;

    dataset: any[];
    totalData: number;
    selectedTitles: any[];
    private respObject: any;
    private clientName: any;
    private notifier: NotifierService;

    displayData: any;
    data: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;

    isError = false;
    errorMessage: string;
    nextOffset: number;
    previousOffset: number;
    collectionSize: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private adminAuth: Subscription;
    loginName: any;
    offset: number;
    dataLoaded: boolean;
    showSearch = true;
    isLoading = false;
    searchUser: FormControl = new FormControl();
    userSelected: any;
    usrs: any;
    userId: number;
    userName: string;

    cPassword:any;
    confirmpassword:any;
    selectedId:any;
    @ViewChild('content1') private content1;
    private modalReference: NgbModalRef;
    signin: FormGroup = new FormGroup({
        // email: new FormControl('', [Validators.email, Validators.required ]),
        password: new FormControl('', [Validators.required, Validators.min(3) ])
      });s
      hide = true;
    //   get emailInput() { return this.signin.get('email'); }
      get passwordInput() { return this.signin.get('password');
     }  

     passwords: FormGroup = new FormGroup({
        // email: new FormControl('', [Validators.email, Validators.required ]),
        password: new FormControl('', [Validators.required, Validators.min(3) ])
      });a
      hides = true;
    //   get emailInput() { return this.signin.get('email'); }
      get passwordInput1() { return this.signin.get('password');
     }  




    constructor(private _rest: RestApiService, notifier: NotifierService,
                private messageService: MessageService, private route: Router, private modalService: NgbModal) {

        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        const data = {
                            name: item.name, mobile: item.mobile, createdBy: this.messageService.getUserId(),
                            address: item.address, email: item.email, password: item.password, id: item.id
                        };
                        this._rest.editUserMst(data).subscribe((res) => {
                            this.respObject = res;
                            if (this.respObject.success) {
                                this.notifier.notify('success', 'Updated successfully');
                            } else {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            }
                        }, (err) => {
                            this.notifier.notify('error', this.messageService.SERVER_ERROR);
                        });
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteUserFrmAdmin({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
    }


    ngOnInit() {

        this.confirmpassword = '';
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain User ',
            openModalButton: 'Add User',
            searchModalButton: 'Search',
            breadcrumb: 'UserCreation',
            folderName: 'All Users',
            tabName: 'User Creation'
        };

        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            

            {
                
                    id: 'edit',
                    field: 'id',
                    excludeFromHeaderMenu: true,
                    formatter: Formatters.editIcon,
                    minWidth: 30,
                    maxWidth: 30,
                    toolTip: 'Change Password',
                    onCellClick: (e: Event, args: OnEventArgs) => {
                        console.log(args.dataContext);
                        this.selectedId = args.dataContext.id;
                        this.clientSelected = args.dataContext.client;

                        
                        this.modalReference = this.modalService.open(this.content1, {size: 'sm'});
                        this.modalReference.result.then((result) => {
                        }, (reason) => {
            
                        });
                    }
            


                

            },
            {
                id: 'name', name: 'Name', field: 'name', sortable: true, filterable: true/*, editor: {
          model: CustomInputEditor,
        }*/
            },
            {
                id: 'login_name', name: 'Login Name', field: 'login_name', sortable: true, filterable: true
            },
            {
                id: 'mobile', name: 'Mobile Number', field: 'mobile', sortable: true, filterable: true/*, editor: {
          model: CustomInputEditor,
        }*/
            },
            {
                id: 'email', name: 'E-Mail', field: 'email', sortable: true, filterable: true/*, editor: {
          model: CustomInputEditor,
        }*/
            }/*,
      {
        id: 'password', name: 'Password', field: 'password', sortable: true, filterable: true, editor: {
          model: CustomInputEditor,
        }
      }*/,
            {
                id: 'address', name: 'Address', field: 'address', sortable: true, filterable: true/*, editor: {
          model: CustomInputEditor,
        }*/
            },
            {
                id: 'client', name: 'Client', field: 'client', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
        this._rest.getClient().subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                this.clients = this.respObject.clients;
                this.clientSelected = 0;
            } else {

            }
        }, function (err) {

        });
        this.dataset = [];

        this.searchUser.valueChanges.subscribe(
            name => {
                if (name.length) {
                    this.isLoading = true;
                    this._rest.searchAllClientAdminRoleMapping(name, this.clientId).subscribe((res1) => {
                        this.respObject = res1;
                        this.isLoading = false;
                        if (this.respObject.success) {
                            this.usrs = this.respObject.details;
                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.isLoading = false;
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this.usrs = [];
                }
            });
    }

    onPageLoad() {
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    confirm(){
    if (this.cPassword === this.confirmpassword) {
                // alert('matched');
                const data = {
                    clientId:this.clientSelected,
                    id:this.selectedId,
                    cPassword:this.cPassword,
                    confirmPassword:this.confirmpassword
            };
                console.log('================'+JSON.stringify(data));
                this._rest.changeUserPassword(data).subscribe((res1) => {
                    this.respObject = res1;
                    if (this.respObject.success) {
                        this.cPassword = '';
                        this.confirmpassword = '';

                        this.notifier.notify('success', 'password Changed');
                    } else {
                        this.notifier.notify('error', this.respObject.errorMessage);
                    }
                }, (err) => {
                    this.notifier.notify('error', this.messageService.SERVER_ERROR);
                });


            } else {
                this.notifier.notify('error', 'New Password and Confirm Password are not matched');
            }


    }

    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.fullname = '';
            this.mobile = '';
            this.email = '';
            this.password = '';
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    searchModal(scarch_content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.fullname = '';
            this.mobile = '';
            this.email = '';
            this.password = '';
            this.userName = '';
            this.userSelected = '';
            this.modalService.open(scarch_content).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    getDetails() {
        for (let i = 0; i < this.usrs.length; i++) {
            if (this.usrs[i].name === this.userSelected) {
                this.userName = this.usrs[i].login_name;
            }
        }
    }

    search() {
        const data1 = [];
        for (let i = 0; i < this.usrs.length; i++) {
            if (this.usrs[i].name === this.userSelected) {
                data1.push(this.usrs[i]);
            }
        }
        this.page_no = 1;
        this.messageService.setTotalData(data1.length);
        this.messageService.setGridData(data1);
    }


    save() {
        const userId = this.messageService.getUserId();
        this.data = {
            user_id: userId,
            clientId: this.clientSelected,
            login_name: this.loginName,
            // mobile: this.mobile,
            // email: this.email,
            mobile: btoa(this.messageService.xorEncode(this.mobile, this.messageService.SECRET_TOKEN)),
            email: btoa(this.messageService.xorEncode(this.email, this.messageService.SECRET_TOKEN)),
            address: this.address,
            password: this.password,
            name: this.fullname
        };
        console.log("-------------------"+JSON.stringify(this.data));
        if (!this.messageService.isBlankField(this.data)) {

            // this.data.password = CryptoJS.AES.encrypt(this.password, this.messageService.SECRET_TOKEN).toString();
            this._rest.insertUser(this.data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.totalData = this.totalData + 1;
                    this.messageService.setTotalData(this.totalData);
                    this.isError = false;
                    const id = this.respObject.userId;
                    this.messageService.setRow({
                        id: id,
                        name: this.fullname,
                        client: this.clientName,
                        mobile: btoa(this.messageService.xorEncode(this.mobile, this.messageService.SECRET_TOKEN)),
                        email: btoa(this.messageService.xorEncode(this.email, this.messageService.SECRET_TOKEN)),
                        address: this.address,
                        login_name: this.loginName
                        // password: this.password
                    });
                    if (this.totalData <= this.pageSize * this.page_no) {
                        this.offset = id;
                        this.nextOffset = 0;
                    } else {
                        this.nextOffset = this.offset;
                    }
                    this.clientSelected = 0;
                    this.fullname = '';
                    this.mobile = '';
                    this.email = '';
                    this.address = '';
                    this.password = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getUsers(offset, this.pageSize, paginationType).subscribe((res) => {

            this.respObject = res;
            console.log('---------' + JSON.stringify(this.respObject));
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {

        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onClientChange(index: any) {
        this.clientName = this.clients[index].name;
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
